import EmailInputWithData from './EmailInputWithData';

export { default as DiEmailInput } from './DiEmailInput';

export default EmailInputWithData;
